import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class DetailedModeService {

  _mode = new BehaviorSubject<String>(null);
  mode: Observable<any> = this._mode.asObservable();

  get = function () {
    return this._mode.getValue();
  };

  set = function (mode: string) {
    this._mode.next(mode);
  };
}
